import type { IconType } from '@deity-io/portal-ui';
import { Button, ButtonGroup, Icon, Menu, MenuItem } from '@deity-io/portal-ui';
import { ListItemIcon, ListItemText } from '@mui/material';
import type { PopoverActionMenuOption } from 'contracts/interfaces/PopoverActionMenuOption';
import type { FC } from 'react';
import { useState } from 'react';

interface MoreButtonProps {
  options: PopoverActionMenuOption<IconType, string, string>[];
  onSelect: (action: string) => void;
}
const MoreButton: FC<MoreButtonProps> = ({ options, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClose = event => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const onOptionSelect = (event: React.MouseEvent<HTMLElement>, option: string) => {
    event.stopPropagation();
    onSelect(option);
    handleClose(event);
  };

  return (
    <>
      <ButtonGroup variant="outlined" onClick={handleClick}>
        <Button variant="outlined" style={{ border: 0 }}>
          <Icon icon="moreVert" color="primary" />
        </Button>
      </ButtonGroup>
      <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={handleClose}>
        {options.map(option => (
          <MenuItem onClick={event => onOptionSelect(event, option.action)} key={option.action}>
            <ListItemIcon>
              <Icon icon={option.icon} />
            </ListItemIcon>
            <ListItemText>{option.text}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MoreButton;
